import styled from "styled-components";
import { mobile, tablet, Button, desktop, CountryPhoneInput } from "src/components";
import ArrowDownSignToNavigate from "src/img/arrow-down-sign-to-navigate.svg";

export const ActionButton = styled(Button)`
    width: ${p => p.width || "140px"};
    background: ${p => p.backgroundColor || "#171A22"};
    color: ${p => p.color || "#FFFFFF"};
    border: ${p => p.border || "1px solid #171A22"};
    height: ${p => p.height || "42px"};
    border-radius: ${p => p.borderRadius || "8px"} !important;
    box-shadow: none;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${p => p.gap || "0px"};
    font-family: 'Manrope', sans-serif;
    font-weight: ${p => p.fontWeight || 400};
`;
// Field and preview container
export const FormContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    max-width: ${p => p.maxWidth || "799px"};
    height: ${p => p.height || "100vh"};
    background: #FFFFFF;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);
    overflow: ${p => p.overflow || "auto"};
    overflow-x: hidden; 
    min-height: 5.625rem;
    border-radius: 16px;
    border: 1px solid #D8DEEC;
    box-sizing: border-box;
    margin-bottom: 2.5rem;
    align-items: center;
    
    ${tablet`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};

    ${mobile`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};

    ${desktop`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};
`;
// Main Container use in Main Add Quotes Page
export const ContentHeaderContainer = styled.div`
    display: flex;
    flex-direction: ${p => p.flexDirection || "row"};
    justify-content: ${p => p.justifyContent || "flex-start"};
    align-items: ${p => p.alignItems || "center"};
    gap: ${p => p.gap || "1rem"};
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth};
    margin-top: ${p => p.marginTop || "1rem"};
    margin-bottom: ${p => p.marginBottom};
    padding: 0.9rem 1rem;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #D8DEEC;
    border-radius: 16px;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);

    @media (max-width: 1440px) {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }

    @media (max-width: 900px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

//Text label
export const TextLabel = styled.div`
    display: flex;
    margin-bottom: ${p => p.marginBottom || "10px"};
    text-align: ${p => p.textAlign || "left"};
    font-family: ${p => p.font || "Manrope, Helvetica, sans-serif"};
    font-weight: ${p => p.fontWeight || p.weight || "normal"};
    font-size: ${p => (p.fontSize || p.size) === "40px" ? "1.75rem" : (p.fontSize || p.size || "15px")};
    line-height: 1.35;
    color: ${p => p.color || "#171A22"} !important;
    opacity: 1;
    overflow-wrap: anywhere;
`;

//  Display Selected Iamge Field
export const ImagePreview = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 14px;
`;

export const InputSelector = styled.select`
    font-size: ${p => p.size || "0.8rem"};
    font-weight: ${p => p.fontWeight || 500};
    height: ${p => p.height || "2.4375rem"} !important;
    width: ${p => p.width || "12.5rem !important"};
    border: 1px solid #D8DEEC;
    box-shadow: none;
    border-radius: 8px;
    padding-left: 1em;
    background-color: #F3F5FB;
    background-image: url(${ArrowDownSignToNavigate});
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: 50%;
    appearance: none;
    margin-right: 2em;
    text-align: left;
    font-family: 'Manrope', 'Arial', sans-serif;
    letter-spacing: 0px;
    color: #171A22;
    ${mobile`
        max-width: 200px;
        margin: 0;
    `}

    ${tablet`
        max-width: 400px;
        margin: 0;
    `}

    ${desktop`
        max-width: 545px;
        margin: 0 ;
    `}
`;

export const StyledCountryPhoneInput = styled(CountryPhoneInput)`
    
    div.flag-dropdown, input.form-control {
        height: 39px !important;
        border: 1px solid #D8DEEC;
        background-color: ${p => p.disabled ? "#EEF2F9 !important" : "#F3F5FB !important"};
    }

    input.form-control{
        width: ${p => p.inputWidth || "70%"} !important;
        margin-left: 55px !important;
        padding-left: 10px !important;
    }

    div.flag-dropdown {
        width: 3rem;
        padding-left: 5px;
    }
`;

export const DialCodeContainer = styled.div`
    position: absolute;
    height: 100%;
    top: 0;
    left: 60px;
    display: flex;
    padding: 0.65rem 0 0;
`;

export const PlanActionButton = styled.button`
    min-width: 140px;
    height: 40px;
    font-weight: 500;
    border-radius: 8px;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    opacity: ${({ disabled }) => (disabled ? 0.9 : 1)};
    transition: all 0.2s ease;

    ${({ variant }) => {
        switch (variant) {
            case "downgrade":
                return `
                    background: #F5F5F5;
                    border: 2px solid #8B8B8B;
                    color: #8B8B8B;
                    box-shadow: none;
                `;
            case "current":
                return `
                    background: #FFFFFF;
                    border: 2px solid #171A22;
                    color: #171A22;
                `;
            case "upgrade":
                return `
                    background: #171A22;
                    border: 2px solid #171A22;
                    color: #FFFFFF;
                `;
            case "cancel-downgrade":
                return `
                    background: #171A22;
                    border: none;
                    color: #FFFFFF;
                    box-shadow: none;
                `;
            default:
                return `
                    background: #171A22;
                    border: 2px solid #171A22;
                    color: #FFFFFF;
                `;
        }
    }}

    &:hover {
        ${({ disabled }) =>
        !disabled &&
            `
            filter: brightness(0.95);
        `}
    }
`;
